<script setup>
  import { notify } from 'notiwind'
  import { askLogin } from '@/utils/ask-login'

  const props = defineProps({
    job: { required: true, type: Object },
    size: { default: 'md', type: String },
    route: { required: true, type: String },
    customClass: { default: '', type: String }
  })

  const { user, fetchUser } = useUser()
  const { create, delete: del } = useStrapi()

  // Favorite local state
  const favorite = ref(user.value?.favorites?.find(favorite => favorite.job.id === props.job.id))

  const toggleFavorite = {
    onClick: async job => {
      if (toggleFavorite.toggling.value) return
      toggleFavorite.toggling.value = true
      try {
        if (favorite.value) {
          await del('favorites', favorite.value.id)
          favorite.value = null
        } else {
          const newFavorite = await create('favorites', { user: user.value.id, job: job.id })
          favorite.value = newFavorite.data
        }
      } catch (error) {
        notify({
          group: 'main',
          type: 'danger',
          title: "Une erreur s'est produite",
          text: 'Si le problème persiste, merci de contacter notre équipe'
        })
      } finally {
        await fetchUser()
      }
      toggleFavorite.toggling.value = false
    },
    toggling: ref(false)
  }
</script>

<template>
  <Icon
    v-if="!user || user.candidate"
    :class="['transition-all duration-300 hover:scale-125 hover:cursor-pointer', customClass]"
    @click.prevent="user ? toggleFavorite.onClick(job) : askLogin(route)"
    name="heart"
    :size="size"
    :type="favorite ? 'solid' : 'regular'"
  />
</template>
